<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 3.76517V14.1181H14V3.76517H2ZM1 1.88281C0.447715 1.88281 0 2.30419 0 2.82399V15.0593C0 15.5791 0.447715 16.0005 1 16.0005H15C15.5523 16.0005 16 15.5791 16 15.0593V2.82399C16 2.30419 15.5523 1.88281 15 1.88281H1Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 0C4.55228 0 5 0.421379 5 0.941176V2.82353C5 3.34333 4.55228 3.76471 4 3.76471C3.44772 3.76471 3 3.34333 3 2.82353V0.941176C3 0.421379 3.44772 0 4 0Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0C12.5523 0 13 0.421379 13 0.941176V2.82353C13 3.34333 12.5523 3.76471 12 3.76471C11.4477 3.76471 11 3.34333 11 2.82353V0.941176C11 0.421379 11.4477 0 12 0Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 7.52981H1V5.64746H15V7.52981Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 9.41188C4 8.89208 4.44772 8.4707 5 8.4707C5.55228 8.4707 6 8.89208 6 9.41188C6 9.93168 5.55228 10.3531 5 10.3531C4.44772 10.3531 4 9.93168 4 9.41188Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 12.2351C4 11.7153 4.44772 11.2939 5 11.2939C5.55228 11.2939 6 11.7153 6 12.2351C6 12.7549 5.55228 13.1763 5 13.1763C4.44772 13.1763 4 12.7549 4 12.2351Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 9.41188C7 8.89208 7.44772 8.4707 8 8.4707C8.55228 8.4707 9 8.89208 9 9.41188C9 9.93168 8.55228 10.3531 8 10.3531C7.44772 10.3531 7 9.93168 7 9.41188Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 12.2351C7 11.7153 7.44772 11.2939 8 11.2939C8.55228 11.2939 9 11.7153 9 12.2351C9 12.7549 8.55228 13.1763 8 13.1763C7.44772 13.1763 7 12.7549 7 12.2351Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 9.41188C10 8.89208 10.4477 8.4707 11 8.4707C11.5523 8.4707 12 8.89208 12 9.41188C12 9.93168 11.5523 10.3531 11 10.3531C10.4477 10.3531 10 9.93168 10 9.41188Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 12.2351C10 11.7153 10.4477 11.2939 11 11.2939C11.5523 11.2939 12 11.7153 12 12.2351C12 12.7549 11.5523 13.1763 11 13.1763C10.4477 13.1763 10 12.7549 10 12.2351Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCalendar",
  props: {
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    size: {
      type: String,
      default: "20"
    }
  }
};
</script>
